import {createElement} from 'rlink-react';
import {NavLink} from 'rlink-router/component';
import Main from 'components/Main';


export default function (params, content) {
  return (<Main title="Home">
    <div key="Home">
      <h1 key="heading">Company of Heroes In-game Web Views</h1>
      <ul key="links">
        <li>
          <NavLink href={{
            view: 'news',
            params: {
              displayLocation: 'home',
            },
          }}>Home-screen promotions </NavLink>
        </li>
        <li>
          <NavLink href={{
            view: 'news',
            params: {
              displayLocation: 'store',
            },
          }}>Store promotions</NavLink>
        </li>
        <li>
          <NavLink href={{
            view: 'twitch',
            params: {
              displayLocation: 'home',
            },
          }}>Home-screen twitch streams</NavLink>
        </li>
      </ul>
    </div>
  </Main>);
}



// WEBPACK FOOTER //
// ./apps/ingame.companyofheroes.com/src/views/home.jsx